import * as React from 'react';
import { useState } from 'react';

import * as styles from './styles.module.css';

export const GitHubButton = () => {
	const storageKey = 'stars';
	const sessionStars = typeof sessionStorage !== 'undefined' && sessionStorage.getItem(storageKey);
	const [stars, setStars] = useState(sessionStars === null ? 0 : sessionStars);

	if (sessionStars === null) {
		const githubUrl = 'https://api.github.com/repos/exogee-technology/graphweaver';
		const data = fetch(githubUrl)
			.then((res) => res.json())
			.then((data) => {
				if (data.stargazers_count) {
					typeof sessionStorage !== 'undefined' &&
						sessionStorage.setItem(storageKey, data.stargazers_count);
					setStars(data.stargazers_count);
				}
			});
	}

	return (
		<div className={styles.widget}>
			<span
				className={styles.btn}
				onClick={() =>
					window.open('https://github.com/exogee-technology/graphweaver', '_blank', 'noopener')
				}
			>
				<svg viewBox="0 0 16 16" width="16" height="16" className={styles.star} aria-hidden="true">
					<path d="M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.751.751 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.818 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Z"></path>
				</svg>
				<span className={styles.spacer}></span>
				<span>Star on GitHub</span>
				<span className={styles.spacer}></span>
				<span className={styles.dot}></span>
				<span className={styles.spacer}></span>

				<a
					className={styles.githubCount}
					href="https://github.com/exogee-technology/graphweaver/stargazers"
					rel="noopener"
					target="_blank"
					aria-label={`Stargazers on GitHub`}
					suppressHydrationWarning
				>
					{stars ? stars : ''}
				</a>
			</span>
		</div>
	);
};
